import { NOTIFICATION_BASE_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { INotificationsResponse } from "./models";

const defaultProvide = () => getToken();

export const useFetchNotification = (
  id: string | number,
  pageNumber: number,
  pageSize: number
): Promise<INotificationsResponse> => {
  const descriptor = new ApiServiceManager(
    `${NOTIFICATION_BASE_URL}${id}?page=${pageNumber}&size=${pageSize}&sort=createdAt,desc`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor, null);
};
export const useSeenNotification = (
  userId: string | number,
  notiiifcationId: number[]
) => {
  const descriptor = new ApiServiceManager(
    `${NOTIFICATION_BASE_URL}users/${userId}/seen?notificationIds=${notiiifcationId}`,
    "PATCH",
    defaultProvide
  );
  return fetchRequest(descriptor, null);
};

export const useSeenAllNotifications = (userId: string | number) => {
  const descriptor = new ApiServiceManager(
    `${NOTIFICATION_BASE_URL}users/${userId}/seen-all`,
    "PATCH",
    defaultProvide
  );
  return fetchRequest(descriptor, null);
};
